export const CHANNEL_TYPE = 'messaging';
